const dropdownSelectors = [
  ".dropdown-menu-scroll",
  ".dropdown-menu",
  "[role='listbox']",
  "[class*='-menu']",
  "[class*='-Menu']",
  "[class*='-menuList']",
  "[class*='-MenuList']",
].join(",");

const getScrollableDropdown = (target) => {
  const dropdown = target?.closest?.(dropdownSelectors);
  if (!dropdown) return null;

  const style = window.getComputedStyle(dropdown);
  const canScroll = dropdown.scrollHeight > dropdown.clientHeight;
  const overflowAllowsScroll = ["auto", "scroll"].includes(style.overflowY);

  if (canScroll || overflowAllowsScroll || dropdown.getAttribute("role") === "listbox") {
    return dropdown;
  }

  const childScroller = Array.from(dropdown.children || []).find((child) => child.scrollHeight > child.clientHeight);
  return childScroller || dropdown;
};

const containWheel = (event) => {
  const dropdown = getScrollableDropdown(event.target);
  if (!dropdown) return;

  event.stopPropagation();

  const atTop = dropdown.scrollTop <= 0;
  const atBottom = Math.ceil(dropdown.scrollTop + dropdown.clientHeight) >= dropdown.scrollHeight;

  if ((atTop && event.deltaY < 0) || (atBottom && event.deltaY > 0)) {
    event.preventDefault();
  }
};

let lastTouchY = 0;

const rememberTouchStart = (event) => {
  if (!getScrollableDropdown(event.target)) return;
  lastTouchY = event.touches?.[0]?.clientY || 0;
};

const containTouchMove = (event) => {
  const dropdown = getScrollableDropdown(event.target);
  if (!dropdown) return;

  event.stopPropagation();

  const currentY = event.touches?.[0]?.clientY || 0;
  const deltaY = lastTouchY - currentY;
  lastTouchY = currentY;

  const atTop = dropdown.scrollTop <= 0;
  const atBottom = Math.ceil(dropdown.scrollTop + dropdown.clientHeight) >= dropdown.scrollHeight;

  if ((atTop && deltaY < 0) || (atBottom && deltaY > 0)) {
    event.preventDefault();
  }
};

const containMouseDown = (event) => {
  if (getScrollableDropdown(event.target)) {
    event.stopPropagation();
  }
};

export const installDropdownScrollLock = () => {
  if (typeof window === "undefined" || window.__zarpDropdownScrollLockInstalled) return;

  window.__zarpDropdownScrollLockInstalled = true;
  document.addEventListener("wheel", containWheel, { capture: true, passive: false });
  document.addEventListener("touchstart", rememberTouchStart, { capture: true, passive: true });
  document.addEventListener("touchmove", containTouchMove, { capture: true, passive: false });
  document.addEventListener("mousedown", containMouseDown, { capture: true });
};
